<template>
  <div class="modal fade" id="returnModal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="closeReturnModal" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title text-warning"><i class="fa fa-reply mr-5"></i>{{'return_header' | translate}}</h4>
        </div>
        <div class="modal-body">
          <h4>{{'return_message' | translate}}</h4>
          <p class="text-warning"><i class="fa fa-warning mr-5"></i>{{'return_mini_message' | translate}}</p>
          <div class="margin"></div>
          <label>{{'reason' | translate}}:</label>
          <select v-model="reason" class="form-control">
            <option class="normal" value="dont_like_item">{{'dont_like_item' | translate}}</option>
            <option class="normal" value="item_too_big">{{'item_too_big' | translate}}</option>
            <option class="normal" value="item_too_small">{{'item_too_small' | translate}}</option>
            <option class="normal" value="price_quality_ratio">{{'price_quality_ratio' | translate}}</option>
            <option class="normal" value="delivery_too_late">{{'delivery_too_late' | translate}}</option>
            <option class="normal" value="item_different_as_shown">{{'item_different_as_shown' | translate}}</option>
            <option class="normal" value="wrong_item">{{'wrong_item' | translate}}</option>
            <option class="normal" value="item_defect">{{'item_defect' | translate}}</option>
            <option class="normal" value="no_reason">{{'no_reason' | translate}}</option>
            <option class="normal" value="address_invalid">{{'address_invalid' | translate}}</option>
            <option class="normal" value="customer_decline">{{'customer_declined' | translate}}</option>
            <option class="normal" value="item_for_choice">{{'item_for_choice' | translate}}</option>
            <option class="normal" value="no_stock_charge_back">{{'no_stock_charge_back' | translate}}</option>
          </select>
          <div class="margin"></div>
          <label>{{'commentary' | translate}}:</label>
          <textarea class="form-control" v-model="message"></textarea>
        </div>
        <div class="modal-footer">
          <b-btn :disabled="message === ''" @click="$emit('action',[reason, message])" type="button" class="btn btn-app no-margin btn-success"><i class="fa fa-save"></i>{{'submit' | translate}}</b-btn>
          <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['action'],
    data () {
      return {
        reason: 'no_reason',
        message: ''
      }
    },
    methods: {
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/ReturnModal.vue